<template>
  <div>
    <div class="form-group row mb-0">
      <div
        class="pb-0 mb-0 text-right"
        :class="[checkboxLayout, layout != 1 && 'position-absolute']"
      >
        <el-checkbox
          v-model="not_found"
          @change="sendChanges"
          class="fa-xs"
          :class="layout == 3 && 'text-black'"
          ><small>Address not found</small></el-checkbox
        >
      </div>
    </div>
    <div class="form-group row" v-if="not_found">
      <label
        for="postal_address"
        class="col-md-3 col-form-label"
        :class="{
          'col-md-3': layout == 1,
          'col-md-12': layout != 1,
          'text-white': layout == 3,
        }"
        >{{ label }}
        <span v-if="data.required" class="required-flag">*</span></label
      >
      <div :class="layout == 1 ? 'col-md-9' : 'col-md-12'">
        <el-input
          placeholder="Address"
          v-model="address.formatted_address"
          class="mb-1"
          @enter="sendChanges"
          :size="([3, 4].includes(layout) && 'small') || 'medium'"
        ></el-input>
        <el-input
          placeholder="Unit"
          v-model="address.unit_number"
          class="mb-1"
          @enter="sendChanges"
          :size="([3, 4].includes(layout) && 'small') || 'medium'"
        ></el-input>
        <div class="row">
          <div class="col-4">
            <el-input
              placeholder="City"
              v-model="address.locality"
              @enter="sendChanges"
              :size="([3, 4].includes(layout) && 'small') || 'medium'"
            ></el-input>
          </div>
          <div class="col-4">
            <el-input
              placeholder="Postcode"
              v-model="address.postal_code"
              @enter="sendChanges"
              :size="([3, 4].includes(layout) && 'small') || 'medium'"
            ></el-input>
          </div>
          <div class="col-4">
            <el-select
              class="w-100"
              v-model="address.administrative_area_level_1"
              @change="sendChanges"
              placeholder="State"
              :size="([3, 4].includes(layout) && 'small') || 'medium'"
            >
              <el-option
                v-for="(state, index) in states"
                :key="index"
                :label="state"
                :value="state"
              />
            </el-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
    layout: {
      type: Number,
      required: false,
      default: 1,
    },
    label: {
      type: String,
      required: false,
      default: "Address",
    },
    checkboxLayout: {
      type: String,
      required: false,
      default: "col-md-12",
    },
  },
  data() {
    return {
      not_found: this.data.not_found ?? false,
      address: this.data.address ?? {
        administrative_area_level_1: null,
        formatted_address: null,
        locality: null,
        postal_code: null,
        unit_number: null,
      },
      states: ["QLD", "NSW", "ACT", "SA", "TAS", "NT", "WA", "VIC"],
    };
  },
  computed: {},
  mounted() {},
  methods: {
    sendChanges() {
      if (!this.not_found) {
        this.address = {
          administrative_area_level_1: null,
          formatted_address: null,
          locality: null,
          postal_code: null,
          unit_number: null,
        };
      } else {
        if (!this.address) {
          this.address = {};
        }
        this.address.route = this.address.formatted_address || "";
      }
      this.$emit("update", {
        not_found: this.not_found,
        address: this.address,
      });
    },
  },
};
</script>
